import React, { FC } from 'react'
import { ChannelTypes } from '../../../../../pages/ChannelPage/channelType'
import { getTranslatedChannelTypeIndefinite } from '../../../../content/RelatedChannel/RelatedChannelItem/getTranslatedChannelTypeIndefinite'

import styles from './ChannelTypeLabel.module.scss'

interface Props {
  channelType: ChannelTypes
}

export const ChannelTypeLabel: FC<Props> = ({ channelType }) => {
  const translatedChannelTypeText =
    getTranslatedChannelTypeIndefinite(channelType)
  return (
    <div
      data-testid="channel-type-label"
      className={styles.ChannelTypeLabelContainer}
    >
      {translatedChannelTypeText}
    </div>
  )
}
